export enum TopFrequency {
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly'
 }